export default [{
    title: 'Página Principal',
    icon: 'HomeIcon',
    route: 'home',
    action: 'read',
    resource: 'ACL'
}]